import Api from '@/api/api'
import configApi from '@/api/config/_api_config'

const options = token => ({ med_access_scoped: true, timeout: 20000, headers: { 'X-Prelevement-Access': token } })

export default {
    async access() {
        const response = await configApi().post('/prelevements/access', {}, { timeout: 20000 })
        if (!response.data.success || !response.data.data || !response.data.data.access_token) throw new Error('Accès au prélèvement indisponible.')
        return response.data.data.access_token
    },
    list(data, token) {
        return Api().post('/bulletin-analyse/attente-prelevement', data, options(token)).then(response => response.data)
    },
    // LAB-002 : accepte la liste d'identifiants historique ou la charge complète { bulletin_ids, contexte, echantillons }
    confirm(payload, token) {
        const data = Array.isArray(payload) ? { bulletin_ids: payload } : payload
        return Api().post('/bulletin-analyse/save-prelevement', data, options(token)).then(response => response.data)
    },
    deposer(data, token) {
        return Api().post('/bulletin-analyse/deposer-echantillons', data, options(token)).then(response => response.data)
    },
    personnelsDepot(token) {
        return Api().get('/bulletin-analyse/personnels-depot', options(token)).then(response => response.data)
    }
}
